/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
import React, { Component } from 'react';
import { DSButton } from '@elliemae/ds-legacy-button-v1';
import { DSCheckbox, DSTextBox, DSInputGroup } from '@elliemae/ds-legacy-form';
import { convertPropToCssClassName, aggregatedClasses } from '@elliemae/ds-classnames';
import { ChevronSmallLeft, ChevronSmallRight } from '@elliemae/ds-icons';

const blockName = 'code-editor';

const { cssClassName, classNameBlock } = convertPropToCssClassName(blockName);

const CheckOptionsGroup = aggregatedClasses('div')(`${blockName}-options-group`);

class DSCodeEditorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      find: false,
      replace: false,
      isCaseSensitive: false,
      isWholeWord: false,
      filteredText: '',
      replaceText: '',
    };

    this.searchWord = this.searchWord.bind(this);
  }

  searchWord(isReplace, all) {
    const {
      reactAceComponent: {
        current: { editor },
      },
    } = this.props;
    const { isCaseSensitive, isWholeWord, filteredText, replaceText } = this.state;
    const options = {
      backwards: false,
      wrap: true,
      caseSensitive: isCaseSensitive,
      wholeWord: isWholeWord,
      regExp: true,
    };
    editor.find(filteredText, options);
    const selectedContent = editor.getSelectedText();
    if (isReplace && replaceText && selectedContent) {
      if (all) {
        editor.findAll(filteredText, options);
        editor.replaceAll(replaceText);
      } else {
        const range = editor.selection.getRange();
        editor.session.replace(range, replaceText);
      }
    }
  }

  render() {
    const { fileName } = this.props;

    const { find, replace, isCaseSensitive, isWholeWord, filteredText, replaceText } = this.state;
    return (
      <div className={`${cssClassName}`}>
        {fileName ? (
          <div className={classNameBlock('file-name')}>
            File Name: <span> {fileName} </span>
          </div>
        ) : null}
        <div className={classNameBlock('find-replace-btn')}>
          {!find && !replace ? (
            <DSButton buttonType="secondary" labelText="Find" onClick={() => this.setState({ find: true })} size="m" />
          ) : null}
          {!replace ? (
            <DSButton
              buttonType="secondary"
              labelText="Find & Replace"
              onClick={() => this.setState({ replace: true })}
              size="m"
            />
          ) : null}
        </div>
        {find || replace ? (
          <DSInputGroup className={classNameBlock('find')}>
            <DSTextBox
              className="find-word"
              fluidWidth={false}
              id="find-textbox"
              onChange={(e) => this.setState({ filteredText: e.currentTarget.value })}
              placeholder="Find"
              rightComponent={
                <div className={classNameBlock('next-back-btn')}>
                  <DSButton icon={<ChevronSmallLeft />} size="m" />
                  <DSButton icon={<ChevronSmallRight />} onClick={() => this.searchWord()} size="m" />
                </div>
              }
              value={filteredText}
            />
            <CheckOptionsGroup>
              <DSCheckbox
                checked={isCaseSensitive}
                id="case-sensitive-check"
                labelText="Case Sensitive"
                name="case-sensitive-check"
                onChange={() => this.setState({ isCaseSensitive: !isCaseSensitive })}
              />
              <DSCheckbox
                checked={isWholeWord}
                id="whole-word-check"
                labelText="Whole Word"
                name="whole-word-check"
                onChange={() => this.setState({ isWholeWord: !isWholeWord })}
              />
              <DSCheckbox
                checked={replace}
                id="replace-check"
                labelText="Replace"
                name="replace-check"
                onChange={() => this.setState({ replace: !replace })}
              />
            </CheckOptionsGroup>
            <DSButton
              buttonType="secondary"
              labelText="Done"
              onClick={() => this.setState({ replace: false, find: false })}
              size="m"
            />
          </DSInputGroup>
        ) : null}
        {replace ? (
          <div className={classNameBlock('replace')}>
            <DSTextBox
              className="find-word"
              fluidWidth={false}
              id="replace-textbox"
              onChange={(e) => this.setState({ replaceText: e.currentTarget.value })}
              placeholder="Replace"
              value={replaceText}
            />
            <div className={classNameBlock('replace-btns')}>
              <DSButton
                buttonType="secondary"
                labelText="Replace"
                onClick={() => this.searchWord(true, false)}
                size="m"
              />
              <DSButton
                buttonType="secondary"
                labelText="Replace All"
                onClick={() => this.searchWord(true, true)}
                size="m"
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default DSCodeEditorForm;
